export const matomoConfig = {
  host: import.meta.env.VITE_MATOMO_URL || 'https://matomo.em-normandie.fr/',
  siteId: Number(import.meta.env.VITE_MATOMO_SITE_ID) || 13,
  disableCookies: true,
  // trackerFileName: 'collect',
  // trackerScriptName: 'collect'
};
